import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

declare var $: any;

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
  error: any;
  date: Date = new Date();

  constructor(
    public afAuth: AngularFireAuth,
    private router: Router,
    private auth: AuthService
  ) { }

  ngOnInit() {
    if (this.auth.authenticated) {
      this.router.navigate(['/']);
    }

    this.checkFullPageBackgroundImage();

    setTimeout(function(){
        // after 1000 ms we add the class animated to the login/register card
        $('.card').removeClass('card-hidden');
    }, 700)
  }

  checkFullPageBackgroundImage(){
    var $page = $('.full-page');
    var image_src = $page.data('image');

    if(image_src !== undefined){
        var image_container = '<div class="full-page-background" style="background-image: url(' + image_src + ') "/>'
        $page.append(image_container);
    }
  };

  loginWithEmail(event, email, password) {
    event.preventDefault();
    this.afAuth.auth.signInWithEmailAndPassword(email, password).then(() => {
      this.router.navigate(['/']);
    }).catch((error: any) => {
      if (error) {
        let errorMessage: string;

        switch(error.code) {
          case 'auth/invalid-email':
            errorMessage = 'Endereço de e-mail inválido';
            break;
          case 'auth/user-disabled':
            errorMessage = 'Conta desabilitada';
            break;
          case 'auth/user-not-found':
            errorMessage = 'E-mail não cadastrado';
            break;
          case 'auth/wrong-password':
            errorMessage = 'Senha incorreta';
            break;
          default:
            errorMessage = error.message;
        }

        this.showNotification(errorMessage);
      }
    });
  }

  showNotification(message) {
  	$.notify({
      	icon: "pe-7s-attention",
      	message: `<b>${message}</b>`
      }, {
        type: 'danger',
        timer: 4000,
        placement: {
          from: 'top',
          align: 'right'
        }
    });
  }

}



// WEBPACK FOOTER //
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/app/signin/signin.component.ts